import * as React from 'react'
import { Button, Link, Typography, IconButton, Box, Paper } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ResponsiblesTable from '../../components/ResponsiblesTable'
import { BlockTitle } from '../../components/UI/BlockTitle/BlockTitle'

export default function ResponsibleForStages() {
  return (
    <>
      <Paper
        sx={{
          padding: '1rem',
          borderRadius: '1rem',
          mt: 3,
          maxWidth: '900px'
        }}
        elevation={0}
      >
        <BlockTitle backUrl="/settings" label="Ответственные за стадии" />
        <ResponsiblesTable />
      </Paper>
    </>
  )
}
